export const bg = {
  docTitle: 'Дора Октопода | {{name}}',
  invite: {
    title: 'Дора Октопода',
    subtitle: 'По какъв проект работиш, приятелю?',
    continueBtn: 'Приемам поканата',
    accept: {
      alreadyAcceptedError:
        'Ей! Тая покана вече е приета. Направо влизай с твоят мейл и парола!',
      title: 'Активиране',
      subtitle: '{{ name }}, въведи парола, за да започнеш 🤗',
      password: 'Сложи си най-могъщата парола',
    },
  },
  auth: {
    forgotPassword: 'Забрави паролата си?',
    backToLogin: '👈 назад към Входът',
    changePassSubmit: 'Промени паролата',
    resetPassSuccessMessage:
      'Изпратихме инструкции за промяна на паролата на твоя мейл.',
    newPass: 'Нова парола',
    repeatPass: 'Повтори паролата',
    newPassSubmit: 'Потвърди новата парола',
    errPasswordsNotMatching: 'Двете въведени пароли не съвпадат.',
  },
  onboarding: {
    addProjects: {
      title: 'По кои проекти работиш?',
      subtitle: 'Стъпка 1 от 3',
      joinProject: 'Присъедини се към вече въведените проекти:',
      addProject: '... или, ако твоите липсват, добави нови:',
      addProjectBtn: '+ нов проект',
      modalTitle: 'Добавяне на проект',
    },
    addSideProjects: {
      title: 'Работиш ли по странични или по свои проекти?',
      subtitle: 'Стъпка 2 от 3',
      joinProject: 'Присъедини се към вече въведените странични проекти:',
      addProject: '... или, ако твоите липсват, добави нови:',
      addProjectBtn: '+ нов проект',
      modalTitle: 'Добавяне на страничен проект',
    },
    addGoals: {
      title: 'Твоите цели',
      subtitle: 'Стъпка 3 от 3',
      addGoals: 'Добави своите годишни цели:',
      addedGoals: 'Твоите цели:',
      continueBtn: 'Това е всичко',
    },
  },
  home: {
    title: 'Къщурка.',
    subtitle: 'Съдържа всички новости от последния нюзлетър насам.',
    message:
      'Всички тези новини ще бъдат пакетирани в нюзлетър и изпратени {{comingIn}}.',
    newMembersTitle: 'Новоприсъединили се',
    newProjectsTitlePrefix: '',
    newProjectsTitle: 'последно добавени',
    newProjectsTitleSuffix: ' [Проекта]',
    newSideProjectsTitlePrefix: '',
    newSideProjectsTitle: 'последно добавени',
    newSideProjectsTitleSuffix: ' {Странични проекта}',
    newSideProjectsTitleSuffixSecondary: ' проекта',
    projectsEventsTitle: 'Активност около проектите',
    goalsTitlePrefix: '',
    goalsTitle: 'Активност около всички',
    goalsTitleSuffix: ' <Цели>',
    noneEvents:
      'Все още няма ъпдейти за текущия период. Бъди готин! Дай пример! Пусни ъпдейт!',
    noneEventsTitle: 'Няма никой вкъщи',
    newsletterArchive:
      'Предишни ъпдейти можеш да откриеш в капсулата на времето (архива с вече изпратени нюзлетъри)',
  },
  users: {
    titlePrefix: '',
    title: 'Съекипници',
    titleSuffix: '',
  },
  footer: {
    note: 'Имаш въпроси? Фийдбек? ',
    noteCallToAction: 'Пиши ни.',
    createdBy: 'Съградено с ❤ и ⌨ от',
    createdByUrl: 'Dev___SPACE___Labs',
  },
  user: {
    viewProfile: 'Към профила',
    editProfile: 'Редактирай',
    editProfileTitle: 'Редактиране на профила',
    projectsTitlePrefix: '[Активни проекта]',
    projectsTitle: ', по които бачка',
    projectsTitleSuffix: '',
    sideProjectsTitlePrefix: '{Странични Проекта}',
    sideProjectsTitle: ', по които бачка',
    sideProjectsTitleSuffix: '',
    archievedProjectsTitlePrefix: '<!-- Неактивни -->',
    archievedProjectsTitle: ' Проекта',
    archievedProjectsTitleSuffix: '',
    goalsTitlePrefix: '',
    goalsTitle: 'Годишни ',
    goalsTitleSuffix: '<Цели>',
    joinOrAddProjectBtn: '+ нов проект',
    noneProjectsAdded: 'Нямаш въведени. Хайде сподели де! 🤗',
    joinProjectLabel: 'Присъедини се към вече добавен проект:',
    addProjectLabel: '... или добави нов проект:',
    addOrJoinProjectTitle: 'Добави проект',
    noneGoalsAdded: 'Нямаш въведени.',
    noneGoalsAddedMotivation:
      'Проучванията сочат, че шансът да постигнеш целите си значително се увеличава, когато ги споделиш с други хора. Част от причините са: 1) Избистряш целите за самия себе си; 2) Чувстваш се отговорен пред другите; 3) Имаш измеримост и мотивация; 4) Това те свързва с хората, които имат подобни цели. Та, защо не ги споделиш? 🤗',
    edit: {
      nameLabel: 'Име',
      namePlaceholder: '',
      emailLabel: 'Пощичка',
      avatarLabel: 'Аватар. Квадратен.',
      avatarPlaceholder: 'https://',
      urlsLabel: 'Твоите линкове, разделени, със, запетайка,',
      urlsPlaceholder: 'https://..., https://..., https://...',
      lang:
        'Език на интерфейса. Можеш да го промениш за теб, но Нюзлетърите и други генерални съобщения винаги ще са на официалния език на твоя екип.',
    },
  },
  events: {
    project: {
      join: 'започна да бачка по',
      join_plural: 'започнаха да бачкат по',
      unjoin: 'вече не бачка активно по',
      unjoin_plural: 'вече не бачкат активно по',
      unjoinWithMultiple: 'пък вече не бачка активно него.',
      unjoinWithMultiple_plural: 'пък вече не бачкат активно по него.',
      addMemo: 'сподели по',
      sharedMemo: 'сподели в лексикона',
      projectsMemoOwn: 'на',
    },
    goal: {
      label: '(1){цел};(2-inf){цели};',
      update: 'ъпдейтна',
      sharedGoalMemos: 'сподели следните неща:',
      sharedForGoal: 'във връзка с целта си:',
    },
  },
  nav: {
    projects: 'Проекти',
    users: 'Екип',
    newsletters: 'Архив',
    menu: 'Меню',
    admin: 'Админ',
  },
  newsletter: {
    archieveTitle: 'Капсула на времето',
    archieveSubtitle: 'Архив с всички изпратени вече нюзлетъри.',
    archieveEmptyTitle: 'Само дето все още няма такива',
    archieveEmptySubtitle:
      'Не са били изпращани нюзлетъри до сега. С нетърпение очаквам първия 🤗',
    itemTitle: 'Нюзлетър #{{number}}',
    comingIn: 'Нюзлетърът иде {{comingIn}}',
    remaining: '{{count}} ден',
    remaining_plural: '{{count}} дни',
    manageYourUpdates: 'Твоите известия',
    confirmYourInfo: '👉 потвърди си инфото 👈',
  },
  admin: {
    adminTitle: 'Здрасти, шефе! 👀',
    adminSubtitle: 'Менажирай. Персонализирай. Покани още народ.',
    title: 'Всички покани',
    addNewMemberBtn: 'Покани нов съекипник',
    editInviteModalTitle: 'Редактирай поканата',
    editInviteModalBtn: 'Запази промените',
    copyLinkBtn: 'Копирай линка',
    copyLinkSuccess: 'Копирано!',
    cancelBtn: 'Откажи',
    undoCancelBtn: 'Активирай обратно',
    invites: 'Покани',
    inviteStatusLabel: {
      SENT: 'Поканата е изпратена',
      CANCELED: 'Поканата е отменена',
      ACCEPTED: 'Поканата е приета и съекипникът се е регистрирал!',
    },
    inviteAvatarUploadEdgeCase:
      'Изпратихме поканата успешно, но има проблем с аватара. Ето какво знаем: {{error}}. Ако желаеш, пробвай отново като редактираш поканата.',
    userName: 'Съекипник',
    userEmail: 'Пощичка',
    userStatus: 'Дередже',
    settings: 'Настройки',
    settingsTitle: 'Настройки на спейса',
    mainSettingsTitle: 'Основни настройки',
    mailSettingsTitle: 'Мейл настройки',
    settingsScreen: {
      loginScreenTitle: 'Логин екран на спейса',
      onboardingScreenTitle: 'Екран при първо влизане',
      subscriptionScreenTitle: 'Абонамент',
      logo: 'Лого',
      logoPlaceholder: 'https://...',
      background: 'Бекграунд',
      backgroundPlaceholder: 'https://...',
      name: 'Име на екипа',
      namePlaceholder: '',
      officialLang:
        'Официален език. Нюзлетър мейлите към екипа и други общи съобщения ще са на този език.',
      updatePeriod:
        'Ъпдейт период. В края на всеки период ще бъде изпратен нюзлетър. Ако искате да го промените, моля, свържете се със съпорт екипа.',
      helloMessage:
        'Поздравче. One-liner. Показва се на Логин екрана на спейса.',
      helloMessagePlaceholder:
        'Това е нашето местенце за споделяне на ъпдейти 🤗',
      onboardingMessage:
        'Веднага след като всеки съекипник отвори своята покана - това са думите, които ще види. Чудесно място за допълнителна персонализирана мотивация. Поддържа HTML.',
      slogan: 'Слоган. Показва се на Логин екрана на спейса.',
      sloganPlaceholder: '',
      emailInvite: {
        title: 'Мейл с покана',
        subject: 'Тема',
        message: 'Съдържание',
      },
      emailReminders: {
        title: 'Мейл с напомняне',
        descr:
          'Мейл с напомняне. Получават го само съекипници, които не са си потвърдили инфото (не са минали през механизма за Fake News). Изпраща се: 3 и 1 ден преди нюзлетъра да бъде изпратен.',
        subject: 'Тема',
        message: 'Съдържание',
      },
      emailStats: {
        title: 'Мейл със статистика',
        descr:
          'Получават го само админи. Изпраща се: 3 и 1 ден преди нюзлетъра да бъде изпратен.',
        subject: 'Тема',
        message: 'Съдържание',
      },
      slack: {
        on: 'Включено',
        off: 'Изключено',
        title: 'Slack интеграция',
        reminder:
          'Slack бот напомняне. Изпраща се: 6, 3 и 1 ден преди нюзлетъра да бъде изпратен.',
        thanks:
          'Благодарствена бележка. Изпраща се точно след като нюзлетъра бъде изпратен.',
        slackBotSettingsTitle: 'Slack бот настройки',
        singleUpdatesTitle: 'Slack бот ъпдейти',
        singleUpdatesDescr: 'Slack бот ъпдейти веднага щом се случи нещо',
        liveUpdates: {
          ADD_USER: 'Когато някой се присъедини в спейса',
          ADD_PROJECT: 'Когато нов проект е добавен',
          JOIN_PROJECT: 'Когато някой започне да работи активно по проект',
          UNJOIN_PROJECT: 'Когато някой вече не работи активно по проект',
          ADD_PROJECT_MEMO:
            'Когато някой сподели нещо в Лексикона на някой проект',
          ADD_GOAL_MEMO: 'Когато някой сподели нещо във връзка с негова цел',
          ADD_GOAL: 'Когато някой добави нова цел',
          COMPLETE_GOAL: 'Когато някой постигне своя цел',
        },
      },
      msteams: {
        on: 'Включено',
        off: 'Изключено',
        title: 'Microsoft Teams интеграция',
        reminder:
          'Бот напомняне. Изпраща се: 6, 3 и 1 ден преди нюзлетъра да бъде изпратен.',
        thanks:
          'Благодарствена бележка. Изпраща се точно след като нюзлетъра бъде изпратен.',
        settingsTitle: 'Бот настройки',
        singleUpdatesTitle: 'Бот ъпдейти',
        singleUpdatesDescr: 'Бот ъпдейти веднага щом се случи нещо',
        liveUpdates: {
          ADD_USER: 'Когато някой се присъедини в спейса',
          ADD_PROJECT: 'Когато нов проект е добавен',
          JOIN_PROJECT: 'Когато някой започне да работи активно по проект',
          UNJOIN_PROJECT: 'Когато някой вече не работи активно по проект',
          ADD_PROJECT_MEMO:
            'Когато някой сподели нещо в Лексикона на някой проект',
          ADD_GOAL_MEMO: 'Когато някой сподели нещо във връзка с негова цел',
          ADD_GOAL: 'Когато някой добави нова цел',
          COMPLETE_GOAL: 'Когато някой постигне своя цел',
        },
      },
      subscription: {
        planTitle: 'Текущ план:',
        plan: {
          TRIAL: 'Пробен период. Безплатно 🤗',
          EARLY_ADOPTER: 'Ранен последовател. Безплатно 🤗',
          REGULAR: 'Активиран абонамент ✅',
          FOREVER_FREE: 'С връзки. Безплатно 🤞',
        },
        periodTitle: 'Период на абонамент:',
        slotsTitle: 'Активирани потребители:',
        valueTitle: 'Стойност на абонамента:',
        valueText: '{{userSlots}} потребители * 4€ = ',
        valueSum: '{{value}}€ на месец',
        transferTitle: 'Детайли за банков превод:',
        bank: {
          recepient: 'BG Leads Ltd',
          bank: 'PROCREDIT Bank',
          bic: 'PRCBBGSF',
          iban: 'BG88 PRCB 9230 1419 3963 18 (EUR)',
        },
        contactTitle: 'Лице за контакт:',
        mobileTitle: 'Мобилен:',
        mailTitle: 'E-mail:',
        contact: {
          name: 'Калоян Косев',
          phone: '+359 883 352 972',
          email: 'superkalo@devlabs.bg',
        },
        clarification:
          '👋 При направен банков превод, моля драснете един мейл до лицето за контакт. От него ще получите потвърждение и фактура за своя абонамент.',
        payNowWarn:
          'Текущият абонаментен период на вашия екип е изтекъл. Моля, наредете плащане за следващ период.',
        lockedTitle: 'Екипното място е заключено',
        lockedTextLine1: 'Абонаментаът на вашия екип бе прекратен.',
        lockedTextLine2:
          'Ако мислите, че това е грешка, моля свържете се с администратора на вашия екип.',
      },
    },
    edit: {
      sentInvite: 'Изпрати поканата',
    },
  },
  manageUpdates: {
    titleConfirm: 'Дела трябват, а не думи!',
    subtitleConfirm:
      'Отдели няколко минутки да потвърдиш инфото за теб. Това е механизъм, с който заедно да преборим fake news.',
    title: 'Твоите текущи известия',
    subtitleConfirmed:
      'Това е механизъм, с който заедно да преборим fake news.',
    titleConfirmed: 'Потвърден си ✅',
    subtitle: 'Това са нещата, които си споделил от последния нюзлетър насам.',
    currentUpdatesTab: 'Текущите известия за теб',
    confirmTab: 'Механизъм за Fake News',
    confirmTabNote: '(ще е активно след {{ count }} ден)',
    confirmTabNote_plural: '(ще е активно след {{ count }} дни)',
    confirmTabNoteActive: '(активно)',
    confirmTabTitle: 'Потвърди още ли бачкаш по:',
    tooltipStillWorkingOn: 'Бачкам активно по този проект',
    tooltipNoLongerWorkingOn: 'Вече НЕ бачкам активно по този проект',
    goalsTitlePrefix: '',
    goalsTitle: 'Ъпдейти по твоите ',
    goalsTitleSuffix: '<Цели>',
    projectsTitlePrefix: '',
    projectsTitle: 'Ъпдейти по твоите Проекти',
    projectsTitleSuffix: '',
    noGoalUpdates: 'Няма промени.',
    noProjectUpdates: 'Няма промени.',
    remove: {
      projectModalTitle: 'Премахване на ъпдейт по проект',
      projectModalNote:
        'Премахвай само в краен случай, ако е станала грешка. Във всички други случаи - може би промяната на статус - активно бачкаш или не бачкаш вече по този проект е по-добро решение?',
      goalModalTitle: 'Премахване на ъпдейт по цел',
      goalModalNote: 'Премахвай само в краен случай, ако е станала грешка.',
    },
    confirmNoUpdates: {
      title: 'НЕ БАЧКАШ ПО НИЩО?',
      note:
        'Не се прави на луд. Иди си в профила и добави проект, по който бачкаш в момента. След това се върни тук, за да потвърдиш.',
      btnTitle: 'Сори, не бачкам по нищо 😕',
    },
    confirmSuccess: {
      title: 'Потвърден си!',
      note:
        'Мерси, че сподели! Ти си супер готин! Помни - ако си стартирал нов проект или има друга новост около теб, винаги можеш да я добавиш.',
    },
    confirmNotYetTheTime: {
      title: 'Ще бъде активно след {{count}} ден',
      title_plural: 'Ще бъде активно след {{count}} дни',
      note:
        'Седмица преди изпращането на нюзлетъра, ще помоля всеки да потвърди дали все още бачка активно по своите проекти. И дали би споделил нещо в Лексиконите им. Реално процесът отнема по няколко минутки :)',
    },
    userStatus: {
      stillWorkingOnTitle: 'Още бачкаш по {{project}} ✅',
      stillWorkingOnMessage: [
        'Завърши ли някой фийчър?',
        'Случи ли ти се нещо интересно през месеца?',
        'Кога ще лаунчнете?',
        'Естимейшънът излиза ли ти?',
        'Кое е най-голямото предизвикателство за теб?',
        'Клиентът дразни ли те?',
        'Използваш ли някоя нова библеотека или фреймуорк?',
        'Каква е твоята роля в проекта?',
        'Кой ти е любимият фийчър в проекта?',
        'Има ли нещо, което направи изключително добре в този проект?',
        'Има ли нещо, което можеше да стане и по-добре?',
        'Какво би променил, ако можеше да пренапишеш проекта?',
      ],
      noLongerWorkingOnTitle: 'Вече не работиш активно по {{project}} 👍',
      noLongerWorkingOnMessage: [
        'Какво полезно научи?',
        'Кое беше най-голямото предизвикателство за теб?',
        'Естимейшънът излезе ли ти?',
        'Каква беше твоята роля в проекта?',
        'Имахте ли функционала спецификация? Ако не - срещнахте ли проблеми заради това?',
        'Клиентът дразнеше ли те?',
        'Кой ти е любимият фийчър в проекта?',
        'Има ли нещо, което направи изключително добре в този проект?',
        'Има ли нещо, което можеше да стане и по-добре?',
        'Какво би променил, ако можеше да пренапишеш проекта?',
      ],
      sharePromptMessage:
        'Ще споделиш ли нещо кратичко в Лексикона на проекта?',
      moreIdeasBtn: 'Дай ми други случайни идеи какво да споделя.',
      nextBtn: 'Това е от мен! Давай напред!',
      shareMoreTitle: 'Сподели още нещо',
      wannaShareBtn: 'Искам да споделя',
      skipShareBtn: ['Не искам', 'Друг път', 'Нищо интересно няма'],
    },
  },
  project: {
    types: {
      default: '[Активни]',
      side: '{Странични}',
    },
    create: {
      nameLabel: 'Име',
      namePlaceholder: '... по-скоро на английски',
      logoLabel: 'Лого. Квадрат.',
      logoPlaceholder: '',
      descrLabel:
        'Кратко описание (по-скоро на български). Максимум колкото 1 tweet.',
      descrMemo: 'За лексикона:',
      descrPlaceholder: '... по-скоро на български',
      descrPlaceholderMemo:
        'Имаш малко повече от 2 tweet-а лимит. Бързи идеи какво да споделиш: ',
      urlLabel: 'Линк към Функционалната спецификация:',
      urlPlaceholder: 'https://...',
      urlsLabel: 'Други линкове, разделени, със, запетайка,',
      urlsPlaceholder:
        'Линк към сайта, мобилния апп или хранилището? Всичко, което би било полезно! Пъхай.',
      addBtn: 'Добави',
      avatarUploadEdgeCase:
        'Запазихме проекта успешно, но има проблем с логото. Ето какво знаем: {{error}}. Ако желаеш, пробвай отново като редактираш проекта.',
    },
    edit: {
      editInfo: 'Редактирай инфото за проекта',
      editInfoTitle: 'Редактиране на проекта',
      editInvolvementStatus: 'Смени си работния статус',
      editInvolvementStatusTitle: 'Сменяне на твоя работен статус',
      addYourself: 'Напъхай ме в проекта',
      involvementStatus: {
        active: 'Активно бачкам по този проект.',
        inactive: 'Вече не бачкам активно по проекта',
        remove:
          'Изтрий проекта от профила ми и заличи историята, свързана с мен',
        note:
          'Внимание! Ако не работиш активно по проекта - просто маркирай горната опция. Не трий историята. Тя е важна за архива.',
      },
      notFound: 'Бум. Този проект вече не съществува.',
    },
    join: {
      title: 'На път си да се присъединиш към проект',
      note:
        'Моля, потвърди присъединяването си към {{name}}. Защото ще пратим нотификейшън на целия свят и да не стане някаква грешка :)',
      confirmBtn: 'Да, всичко е точно',
      joinUserToProjectTitle: 'Напъхай се в проекта',
      involvementStatus: {
        active: 'Активно бачкам по този проект.',
        inactive: 'Преди съм бачкал по този проект.',
      },
    },
    details: {
      title: 'Информация на проекта',
      titleActivelyWorkingMembers:
        'Съекипници, които активно работят по проекта:',
      titleInactivelyWorkingMembers: 'Преди по този проект са работили:',
    },
    memo: {
      title: 'Лексикон',
      noMemos:
        'Никой нищо не е споделил все още. Всички мълчат като риби. Бъди за пример. Сподели първи! 🤗',
      btn: 'Сподели нещо',
      modalTitle: 'Сподели нещо интересно, свързано с този проект 🤗',
      titleDate: 'Споделено',
      thanksButtonText: ' благодари, че сподели.',
      thanksButtonText_plural: ' благодарят, че сподели.',
      thanksButtonUsers: ' съекипник',
      thanksButtonUsers_plural: ' съекипници',
      thanksButtonAndMore: ' и още',
      submitThanks: '... изпращам благодарности',
      cancelThanks: '... отменям благодарностите',
      submit: 'Сподели',
    },
    all: {
      activeProjectsTitlePrefix: '[Активни] ',
      activeProjectsTitle: 'Проекта ',
      activeProjectsTitleSuffix: '',
      activeSideProjectsTitlePrefix: '{Странични} ',
      activeSideProjectsTitle: 'Проекта',
      activeSideProjectsTitleSuffix: '',
      archievedProjectsTitlePrefix: '<!-- Неактивни --> ',
      archievedProjectsTitle: 'Проекта',
      archievedProjectsTitleSuffix: '',
    },
  },
  goal: {
    noGoals: 'Няма въведени цели.',
    create: {
      placeholder: 'Твоята S.M.A.R.T. цел',
      addGoal: '+ нова цел',
      editGoalTooltip: 'Редактирай своята цел',
      deleteGoalTooltip: 'Изтрий своята цел',
      addUpdateTooltip: 'Сподели нещо, свързано със своята цел',
      goalDueDateTitle: 'Ще изпълня целта до края на',
      smartGoalsTitle: 'Какво означава S.M.A.R.T. цел?',
      specificDescr: 'Целта ти трябва да бъде точна, ясна и конкретна.',
      measurableDescr: 'Важно е да си поставяш измерими цели.',
      achievableDescr: 'Твоята цел трябва да бъде реалистична и постижима.',
      relevantDescr: 'Увери се, че целта ти е значима за теб.',
      timeboundDescr: 'Не забравяй, че целите са мечти с краен срок.',
      learnMore: 'Научи повече за S.M.A.R.T. целите',
    },
    memo: {
      modalTitle: 'Сподели нещо интересно, свързано с тази цел 🤗',
      descrPlaceholderMemo: '...',
      descrMemo: 'Ъпдейт от мен',
      thanksButtonText: ' изпрати комплименти.',
      thanksButtonText_plural: ' изпратиха комплименти.',
      submitThanks: '... изпращам комплименти',
      cancelThanks: '... отменям комплиментите',
    },
  },
  search: {
    placehoder: '... мен ли търсиш?',
    titleUsers: '@Съекипници',
    titleProjects: '@Проекти',
    noProjectsFound: 'Ах! Абсолютно нищо не намерих.',
  },
  notFound: {
    title: 'Ах! Няма такова нещо! Грешка 404.',
  },
  expiredTokenTrick:
    'Тоукъна ти за достъп е изтекъл. Автоматичното обновяване на тоукън не е имплементирано все още 🙄. Тъй че, ще трябва да се ре-логнеш ръчно 🏃 използвайки ей тоя бутон 👇',
  general: {
    error: 'Оооооопс. 👷 Възникна някаква грешка 💥💥💥',
    okay: 'Ами, добре',
    loading: 'Зареждане...',
    sending: 'Изпращам...',
    activate: 'Активирай',
    login: 'Влез',
    email: 'Мейл',
    password: 'Кажи паролата',
    chooseProject: 'Избери проект',
    continue: 'Напред',
    save: 'Запази',
    saving: 'Запазване...',
    cancel: 'Отказ',
    logout: 'Изход',
    saveChanges: 'Запази промените',
    goHome: 'Иди в къщурката',
    goArchive: 'Иди в архива',
    goGoals: 'Иди си виж целите',
    goProjects: 'Иди си виж проектите',
    goProfile: 'Иди си в профила',
    delete: 'Изтрий',
    oopsCancel: 'Опси, грешка беше. Отказ.',
    edit: 'Редактирай',
    functionalSpecification: 'Функционална спецификация',
    and: 'и',
    doraName: 'Дора Октопода',
    workInProgress: 'В процес на разработване.',
    words: 'думи',
    chars: 'символа',
  },
};



// WEBPACK FOOTER //
// ./src/translations/bg.js